<template>
  <generic-modal
    size=""
    :title="$t('movement type configuration')"
    icon="exchange"
    image="/images/icons/branch.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="ui top attached tabular menu">
          <a class="active item" data-tab="general">{{ $t("general") }}</a>
          <a class="item" data-tab="arrear">{{ $t("arrear") }}</a>
        </div>
        <div class="ui bottom attached active tab segment" data-tab="general">
          <h4 class="ui dividing header">
            <i class="info icon"></i>
            {{ $t("general info") }}
          </h4>
          <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="type.name" />
          </div>
          <h4 class="ui dividing header">
            <i class="settings icon"></i>
            {{ $t("settings") }}
          </h4>
          <!-- <div class="two fields"> -->
          <div class="field">
            <label for>{{ $t("default amount") }}</label>
            <input
              type="text"
              name="default_amount"
              v-model="type.setup.default_amount"
            />
          </div>
          <!-- <div class="field">
              <label for>{{ $t("expire") }}</label>
              <div class="ui toggle checkbox" ref="document_checkbox">
                <input type="checkbox" />
                <label>{{ $t("document required") }}</label>
              </div>
            </div> -->
          <!-- </div> -->
        </div>
        <div class="ui bottom attached tab segment" data-tab="arrear">
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("expire policy") }}</label>
              <div class="ui selection dropdown" ref="expire_policy_dropdown">
                <input type="hidden" name="ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="n">{{ $t("none") }}</div>
                  <div class="item" data-value="g">
                    {{ $t("grace period") }}
                  </div>
                  <div class="item" data-value="s">
                    {{ $t("specific day of month") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="field" v-bind:class="{ hidden: arrear_policy != 's' }">
              <label for=""> {{ $t("day of month") }} </label>
              <input type="text" v-model="type.setup.arrear.specific_day" />
            </div>
            <div class="field" v-bind:class="{ hidden: arrear_policy != 'g' }">
              <label for=""> {{ $t("grace days") }} </label>
              <input type="text" v-model="type.setup.arrear.grace_days" />
            </div>
          </div>

          <div class="three fields">
            <div
              class="field"
              v-bind:class="{ hidden: !['s', 'g'].includes(arrear_policy) }"
            >
              <label for>{{ $t("arrear policy") }}</label>
              <div class="ui selection dropdown" ref="arrear_policy_dropdown">
                <input type="hidden" name="arr_ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="p">
                    {{ $t("percent charge") }}
                  </div>
                  <div class="item" data-value="f">
                    {{ $t("fixed charge") }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="field"
              v-bind:class="{ hidden: !['s', 'g'].includes(arrear_policy) }"
            >
              <label for=""> {{ $t("arrear amount") }} </label>
              <input type="text" v-model="type.setup.arrear.amount" />
            </div>
            <div
              class="field"
              v-bind:class="{ hidden: !['s', 'g'].includes(arrear_policy) }"
            >
              <label for>{{ $t("movement type") }}</label>
              <div class="ui selection dropdown" ref="movement_type_dropdown">
                <input type="hidden" name="movement_type" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui message error"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api /*, stringify */ } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  name: "MovementTypeModal",
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    type_in: Object,
  },
  computed: {},
  data() {
    return {
      type: {
        uuid: "",
        name: "",
        setup: {
          default_amount: "",
          document_required: "",
          arrear: {
            policy: "",
            specific_day: "",
            grace_days: "",
            policy_1: "",
            amount: "",
            movement_type: "",
          },
        },
      },
      arrear_policy: "",
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/account_movement_type/do-save", {
            u: vm.type.uuid,
            n: vm.type.name,
            s: vm.type.setup,
          })
            .then((response) => {
              vm.$emit("updated", response);
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
  },
  created() {
    if (this.type_in) {
      this.type.uuid = this.type_in.uuid;
      this.type.name = this.type_in.name;
      if (this.type_in.setup) {
        if (typeof this.type_in.setup == "object")
          this.type.setup = this.type_in.setup;
        else if (typeof this.type_in.setup == "string")
          this.type.setup = JSON.parse(this.type_in.setup);
      }

      if (this.type.setup) {
        if (!this.type.setup.arrear) this.type.setup.arrear = { policy: "" };
      }
    }
  },
  mounted() {
    let vm = this;

    window.jQuery(".ui.menu .item").tab();
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    window.jQuery(vm.$refs.document_checkbox).checkbox({
      onChange: () => {
        vm.type.setup.document_required = window
          .jQuery(vm.$refs.document_checkbox)
          .checkbox("is checked");
      },
    });

    window.jQuery(vm.$refs.expire_policy_dropdown).dropdown({
      onChange(value) {
        vm.type.setup.arrear.policy = value;
        vm.arrear_policy = value;
      },
    });

    window.jQuery(vm.$refs.arrear_policy_dropdown).dropdown({
      onChange(value) {
        vm.type.setup.arrear.policy_1 = value;
      },
    });

    if (vm.type.setup.arrear.policy)
      window
        .jQuery(this.$refs.expire_policy_dropdown)
        .dropdown("set selected", vm.type.setup.arrear.policy);

    if (vm.type.setup.arrear.policy_1)
      window
        .jQuery(this.$refs.arrear_policy_dropdown)
        .dropdown("set selected", vm.type.setup.arrear.policy_1);

    local_api(vm, "post", "/account_movement_type/do-get-list", {})
      .then((response) => {
        if (response) {
          let typs = response.map((r) => {
            return { name: r.name, value: r.type_id };
          });

          window
            .jQuery(this.$refs.movement_type_dropdown)
            .dropdown("setup menu", { values: typs })
            .dropdown({
              onChange(value) {
                vm.type.setup.arrear.movement_type = value;
              },
            });

          if (vm.type.setup.arrear.policy_1)
            window
              .jQuery(this.$refs.movement_type_dropdown)
              .dropdown("set selected", vm.type.setup.arrear.movement_type);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    /** Set checkbox */
    // if (vm.type.setup.affect == "C") {
    //   window.jQuery(vm.$refs.affect_checkbox).checkbox("set checked");
    // } else if (vm.type.setup.affect == "D") {
    //   window.jQuery(vm.$refs.affect_checkbox).checkbox("set unchecked");
    // } else if (vm.type.setup.affect == "N") {
    //   window.jQuery(vm.$refs.affect_checkbox).checkbox("set indeterminate");
    // }
  },
  updated: function() {},
};
</script>
